import styles from 'styles/modules/subscription/Subscription.module.scss';

const Toggle = ({ index, setIndex }) => (
    <div className={styles.toggleWrapper}>
        <div className={styles.toggle}>
            <div
                className={[
                    styles.toggleButton,
                    index === 0 ? styles.left : styles.right,
                ].join(' ')}
            />
            <span
                className={[index === 0 ? styles.active : ''].join(' ')}
                onClick={() => setIndex(0)}
            >
                Monthly
            </span>
            <span
                className={[index === 1 ? styles.active : ''].join(' ')}
                onClick={() => setIndex(1)}
            >
                Annual
            </span>
        </div>
        <div className={styles.tooltip}>Get 20% off!</div>
    </div>
);

export default Toggle;
